import { render, staticRenderFns } from "./CoupassProductLabel.vue?vue&type=template&id=39dce287&scoped=true"
import script from "./CoupassProductLabel.vue?vue&type=script&lang=js"
export * from "./CoupassProductLabel.vue?vue&type=script&lang=js"
import style0 from "./CoupassProductLabel.vue?vue&type=style&index=0&id=39dce287&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dce287",
  null
  
)

export default component.exports